(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icons-page-information"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('[data-swiper-icons]', {
    slidesPerView: 5,
    spaceBetween: 6,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },

    breakpoints: {
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 4.5,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
